

<button mat-icon-button class="TE_TopBarButton" [matTooltip]=" 'app.language-selector.tooltip' | translate "  aria-label="Language" (click)="onLanguageSelect()">
    <mat-icon class="TE_TopBarIcon">language</mat-icon>
  </button>

